import React from "react";

// Files Import
import "./SocialButton.css";
import { Link } from "react-router-dom";
import { content } from "../../../data";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";

const SocialButton = () => {
  return (
    <div className="card relative flex items-center justify-center bg-[#e7e7e7] shadow-xl overflow-hidden h-[30px] w-[160px] rounded-[4px]">
      <span className="absolute flex items-center justify-center w-full h-full text-white z-10">
        <StyledMdText>Social Links</StyledMdText>
      </span>
      <div className="flex w-full justify-evenly">
        {content.socialIcons.map((items, index) => (
          <Link
            className="social-link"
            key={index}
            to={items.link}
            target="_blank"
          >
            {items.icon}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SocialButton;
